import axios from 'axios';

const BASE_URL = `http://localhost:3002/api/scrape-collection`;
// const BASE_URL = `${getShowroomUrl()}api/scrape-collection`;

export interface IScrapedProduct {
  productUrl: string;
  productTitle: string;
  productIndex: string;
  description: string;
  features: string[];
  width: string;
  height: string;
  depth: string;
  images: { base64: string; mime: string }[]; // base64 with mime
}

export interface IScrapeCollectionResponse {
  products: IScrapedProduct[];
  message?: string;
  ok?: boolean;
  status?: number;
}

const scrapeCollection = async (url: string): Promise<IScrapeCollectionResponse> => {
  try {
    const res = await axios.get(BASE_URL, { params: { url } });
    return {
      products: res.data.products,
      ok: true,
      status: res.status,
    };
  } catch (error) {
    return {
      products: [],
      ok: false,
      status: 400,
      message: 'Nie udało się pobrać kolekcji',
    };
  }
};

const ClarnetController = {
  scrapeCollection,
}

export default ClarnetController;